import React, { useState } from 'react';
// Global library
import { ContentDiv } from '../../../components/Containers';
import { ContentTitle } from '../../../components/layouts/ContentTitle';
import { PortfolioLightbox } from '../../../components/interfaces/PortfolioLightbox';
import { ProjectDescription } from '../../../components/layouts/ProjectDescription';
import { ProjectPreviews } from '../../../components/layouts/ProjectPreviews';
// Module library
import { PROJECT_TRACKER_DATA } from '../data/projectTracker';

const ProjectTracker = () => {
  const [isOpen, setOpen] = useState(false);
  const [currentImageIndex, setCurrentIndex] = useState(0);

  const { desc, previews, title } = PROJECT_TRACKER_DATA;

  return (
    <ContentDiv>
      <ContentTitle title={title} />
      <ProjectDescription projectDescriptionArray={desc} />
      <ProjectPreviews
        projectPreviewsArray={previews}
        setCurrentIndex={setCurrentIndex}
        onOpen={() => setOpen(true)}
      />
      <PortfolioLightbox
        currentImageIndex={currentImageIndex}
        setCurrentIndex={setCurrentIndex}
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        images={previews}
      />
    </ContentDiv>
  );
};

export default ProjectTracker;
